import { ProductGridItem } from "@hatch-digital-nl/bravilor-storybook";
import { ProductInterface } from "../../interfaces/ProductInterface";
import { JSX } from "react";
import { useNavigate } from "react-router-dom";
import { convertProduct } from "../../utils/productConverter";
import { asStorybookProduct } from "../../utils/storybookProduct";
import { SimpleProduct } from "../../interfaces/SimpleProduct";
import { RouteEnum } from "../../enums/RouteEnum";

interface Props {
    category: string;
    resultCount: number;
    products: ProductInterface[];
    productImages: { [key: string]: string };
}

export const ResultCategory = (props: Props): JSX.Element => {
    const { category, resultCount, products, productImages } = props;
    const navigate = useNavigate();

    const handleProductClick = (product: SimpleProduct): void => {
        navigate(RouteEnum.PRODUCT_RANGE + `/${product.id}`);
    };

    return (
        <div className="c-result-category">
            <div className="c-result-category__header">
                <div className="c-result-category__header__title">
                    <span>{category}</span>
                </div>
                <div className="c-result-category__header__amount">
                    {resultCount}
                </div>
            </div>

            {products.length > 0 && (
                <div className="c-result-category__container">
                    {products.map((product) => {
                        const gridProduct: SimpleProduct = convertProduct(
                            product,
                            productImages,
                            "grid",
                        );

                        return (
                            <ProductGridItem
                                key={"grid-" + product.id}
                                product={asStorybookProduct(gridProduct)}
                                viewProductText={"View Product"}
                                showSelectCheckbox={false}
                                onProductClick={(selectedProduct) =>
                                    handleProductClick(
                                        selectedProduct as SimpleProduct,
                                    )
                                }
                            />
                        );
                    })}
                </div>
            )}
        </div>
    );
};
